import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { MessageService } from '@klickdata/core/message';
import { MessageErrorComponent } from '@klickdata/core/message/src/message-error/message-error.component';
import { PaymentService } from '@klickdata/core/payment';
import { PaymentItem, PaymentMethod } from '@klickdata/core/payment/src/payment.model';
import { SubsPlan } from '@klickdata/core/payment/src/payment.service';
import { Utils } from '@klickdata/core/util';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { Observable, Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-chat-io-payment-manager',
    templateUrl: './chat-io-payment-manager.component.html',
    styleUrls: ['./chat-io-payment-manager.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatIoPaymentManagerComponent extends OnDestroyHandler implements OnInit, OnDestroy, AfterViewInit {
    @Input() stepIndex: number;
    @Input() subscriptionPlanId: number;
    @Input() subscriptionPlans: SubsPlan[];
    @Input() isLoading$: Observable<boolean>;
    public subscriptionPlan: SubsPlan;
    public paymentMethods: PaymentMethod[];
    public subscriptionPlanControl = new FormControl(1, Validators.required);
    public termsCheckControl = new FormControl(true, Validators.required);
    public gatewayControl = new FormControl('', Validators.required);
    @ViewChild('stepper') stepper: MatStepper;
    @Output() paymentSucceeded: EventEmitter<boolean> = new EventEmitter();

    constructor(
        protected cdr: ChangeDetectorRef,
        protected messageService: MessageService,
        protected paymentService: PaymentService
    ) {
        super();
        this.paymentMethods = Utils.getPaymentMethods().filter((method) => !method.disabled);
    }

    ngOnInit(): void {
        this.subscriptionPlanControl.patchValue(this.subscriptionPlanId ?? 1);

        this.subscriptionPlanControl.valueChanges
            .pipe(startWith(this.subscriptionPlanId ?? 1), takeUntil(this.destroy))
            .subscribe(
                (subsPlanId) => (this.subscriptionPlan = this.subscriptionPlans.find((plan) => plan.id === subsPlanId))
            );
    }
    ngAfterViewInit(): void {
        if (this.stepper) {
            this.stepper.selectedIndex = this.stepIndex;
        }
    }
    public readMoreLink() {
        window.open('https://klickdata.se/faq-klms/legal-links-for-klick-data', '_blank');
    }

    public purchasePermission() {
        if (!this.termsCheckControl.value) {
            this.messageService.openMessage(MessageErrorComponent, $localize`Please accept the terms first`);
        }
    }
}
